export function hasApplicationGrant(
  application: string,
  permissions: Set<string>,
  attributes: Set<string>,
): boolean {
  const prefix = `${application}:`;
  const belongsToApplication = (grant: string) => grant.startsWith(prefix);

  for (const permission of permissions) {
    if (belongsToApplication(permission)) return true;
  }
  for (const attribute of attributes) {
    if (belongsToApplication(attribute)) return true;
  }
  return false;
}
